module.exports = __webpack_public_path__ + "static/media/icon-job.f958ab57.svg";